import { useAppSelector } from "../app/hooks";
import { selectBooking } from "../features/booking/bookingSlice";
import Loader from "./Loader";
import { formatDateLong } from "../helpers/date";
import { useTranslation } from "react-i18next";
import FormatPrice from "./Helpers/FormatPrice";

export function TopCart() {
  const booking = useAppSelector(selectBooking);
  const { t } = useTranslation();


  return (
    <div className="w-full pb-4 pt-0 text-fluid-base">
      {booking.EndUtc !== null && booking.Error === null && (
        <div className={`flex justify-between items-center`}>
          <div>
            {` ${booking.NightCount} ${t("scenes.night", {
              count: booking.NightCount,
            })} `}{" "}
            <span className={`text-fluid-sm transition-opacity duration-500`}>
              ({formatDateLong(booking.StartUtc, false)}
              {" - "}
              {formatDateLong(booking.EndUtc, false)})
            </span>
          </div>
          {booking.ReservationPrice.State === "show" && (
            <div className="flex gap-4">
              {/* <div className="text-gray-500 line-through">
                <FormatPrice
                  price={booking.ReservationPrice.GrossValue}
                  competitorPrice={true}
                />
              </div> */}
              <div>
                <FormatPrice
                  price={booking.ReservationPrice.GrossValue}
                  competitorPrice={false}
                />
              </div>
            </div>
          )}
          {booking.ReservationPrice.State === "loading" && <Loader />}
        </div>
      )}
    </div>
  );
}
